<template>
  <div class="page-head-container">
    <div class="page-head clearfix">
      <div class="page-head-info columns clearfix">
        <div
          v-if="hasHeaderTopSlot"
          class="page-head-extra-top"
        >
          <slot name="header-top" />
        </div>
        <div
          v-show="shouldNavBack && !hasHeaderTopSlot"
          class="nav-bar"
        >
          <a @click="navBack()">
            &lt; {{ $i18n.t( 'back') }}
          </a>
        </div>
        <div class="page-head-project-info clearfix">
          <div class="page-project__number">
            # {{ number }}
          </div>
          <div class="row page-project__name">
            <div>{{ description }}<slot name="options" /></div>
          </div>
        </div>

        <Lifecycle
          ref="projectLifecycle"
          :type="'project'"
          :showCommentCol="false"
          :histories="currentProjectHistory"
          :emptyHistoryHint="emptyProjectLifecycle"
        />

        <div class="status-actions clearfix">
          <slot name="status">
            <div
              v-if="status"
              class="status float-left"
              :class="statusStyle"
              @click="openLifecycleModal()"
            >
              {{ status }}
            </div>
          </slot>
          <div class="actions clearfix">
            <slot name="buttons" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import HomeLink from '@/controls/HomeLink'
import Lifecycle from '@/modules/Lifecycle'

export default {
  name: 'PageInfoHeader',
  components: {
    HomeLink,
    Lifecycle,
  },
  props: {
    number: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    shouldNavBack: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {emptyProjectLifecycle: this.$t('hint.emptyTenantProjectLifecycle')}
  },
  computed: {
    ...mapGetters('projects', ['currentProjectHistory']),
    hasHeaderTopSlot () {
      const s = this.$slots['header-top']
      return Array.isArray(s) && s.length > 0
    },
    statusStyle () {
      if (this.status) {
        const lowerCasestatus = this.status.toLowerCase()
        return `status-${lowerCasestatus} project-status`
      }
      return ''
    },
  },
  methods: {
    navBack () {
      this.$router.goBack()
    },
    openLifecycleModal () {
      this.$refs.projectLifecycle.init()
    },
  },
}
</script>

<style lang="scss" scoped>
.page-head-container {
  background-color: #ebebeb;
}
.page-head {
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  background-color: #ebebeb;
  padding: 15px 24px;
}

.page-head-info {
  width: 100%;
}

.page-head-extra-top ::v-deep a.back {
  font-family: Verdana;
  font-size: 14px;
  color: #0c3a58;
}

.page-head-project-info {
  margin: 14px 0;
}

.page-project__number{
  font-family: Verdana;
  font-size: 18px;
  color: #0c3a58;
}

.page-project__name {
  font-family: Georgia;
  font-size: 32px;
  color: #0c2b46;
}

.status-actions {
  width: 100%;
  display: inline-block;

  .actions {
    float: right;
  }
}

.status {
  font-size: 14px;
  line-height: 15px;
  font-weight: bold;
  text-align: center;
  color: #6e7a92;
  padding: 10px 9px;
  border: solid 1px #6e7a92;
}

.status-wappr {
  color: #e69500;
  border: solid 1px #e69500;
}

.status-appr, .status-active {
  color: #009588;
  border: solid 1px #009588;
}

.status-issued {
  color: #ae7001;
  border: solid 1px #ae7001;
}

.status-closed, .status-cancelled {
  color: #f44336;
  border: solid 1px #f44336;
}

.status-review {
  color:  #7596c9;
  border: solid 1px #7596c9;
}

.nav-bar {
  font-family: Verdana;
  font-size: 12px;

  a {
    color: #0C3A58;
  }
  i {
    margin-right: 0.5vw;
    font-size: 16px;
  }
}

.project-status {
  cursor: pointer;
}

</style>
